export default "__VITE_ASSET__5c742f3f__"